import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

const copy = {
  heading: `Customer Data Maturity Evaluation`,
}

const Hero = () => (
  <Wrapper>
    <HeroComponent variant="centered">
      <HeroRecipe.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading variant="h2" tag="h1">
            {copy.heading}
          </CopyText.Heading>
        </CopyTextBase>
      </HeroRecipe.Copy>
    </HeroComponent>
  </Wrapper>
)

const Wrapper = styled.header``

const HeroComponent = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    gap: 0;
  }
`

export default Hero
